<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import './_index.scss'

import { delay } from '@/utils/delay'

const { t } = useI18n()

const emit = defineEmits(['animation-end'])

const isMinimized = ref(false)

onMounted(async () => {
  await delay(4000)
  isMinimized.value = true
  await delay(500)
  emit('animation-end')
})
</script>

<script lang="ts">
export default {
  name: 'ChatOverlaySamPresentation'
}
</script>

<template>
  <div
    class="sam-animated-presentation py-20 px-24"
    :class="{ 'minimized': isMinimized }">
    <div class="relative">
      <div class="sam-animated-presentation__bubble bg-white text-carbon-800 rounded-xl py-10 px-16 absolute top-32 right-20 shadow-lg">
        <p>
          {{ t('messageBubble.greeting') }}
        </p>

        <p class="font-bold">
          {{ t('messageBubble.presentation') }}
        </p>
      </div>

      <div class="sam-animated-presentation__photo">
        <img
          class="h-full w-[300px] h-[300px] object-contain"
          src="https://lahaus.imgix.net/static/lh-landing/sam-onboarding.png"
          alt="Sam">
      </div>
    </div>

    <div class="sam-animated-presentation__description my-24">
      <div v-sanitize="t('description')" />
    </div>
  </div>
</template>

<i18n src="./i18n.json" lang="json" />
